function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import PropTypes from 'prop-types';
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import { ClassNames } from '@emotion/core';
import Scrollbar from '../Scrollbar/Scrollbar';
import Selector from '../Selector/Selector';
import Menu from '../Menu/Menu';
import style from './SpecialSelector.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
const MENU_ANCHOR_ORIGIN = {
  horizontal: 'left',
  vertical: 'bottom'
};
const MENU_TRANSFORM_ORIGIN = {
  horizontal: 'left',
  vertical: 'top'
};
const LIST_MAX_HEIGHT = 'calc(100vh - 96px)';
const VIEW_PROPS = {
  style: {
    marginBottom: 0,
    maxHeight: LIST_MAX_HEIGHT
  }
};

const SpecialSelector = ({
  selectorDecoration,
  title,
  className,
  renderChildren,
  titleClassName,
  menuPaperClass,
  testID,
  onSelect,
  anchorOrigin,
  transformOrigin,
  scrollbarRole,
  buttonAttributes
}) => ___EmotionJSX(ClassNames, null, ({
  css
}) => ___EmotionJSX(Menu, {
  renderTarget: ({
    handleTargetClick,
    isOpen
  }) => ___EmotionJSX(ClassNames, null, ({
    css: selectorCss
  }) => ___EmotionJSX(Selector, {
    leftDecoration: selectorDecoration,
    rightDecoration: ___EmotionJSX(KeyboardArrowDown, {
      css: style.unfoldIcon
    }),
    title: title,
    Icon: KeyboardArrowDown,
    classes: {
      title: `${style.selectorTitleClass(selectorCss)} ${titleClassName} `,
      button: style.selectorButtonClass(selectorCss)
    },
    onClick: handleTargetClick,
    buttonAttributes: _objectSpread(_objectSpread({}, buttonAttributes), {}, {
      'aria-expanded': isOpen
    })
  })) // TODO: replace with a token when https://github.com/AulaEducation/aulaui-next/pull/76 is merged
  ,
  zindex: 1300,
  anchorOrigin: anchorOrigin,
  transformOrigin: transformOrigin,
  className: className,
  classes: {
    paper: `${style.menuPaperClass(css)} ${menuPaperClass} `,
    menu: style.menuClass(css)
  },
  testID: testID,
  ariaLabelledby: testID,
  renderChildren: renderParams => ___EmotionJSX(Scrollbar, {
    autoHide: true,
    autoHeight: true,
    role: scrollbarRole,
    autoHeightMax: LIST_MAX_HEIGHT,
    viewProps: VIEW_PROPS
  }, ___EmotionJSX("div", {
    css: style.content
  }, renderChildren(renderParams))),
  onSelect: onSelect
}));

const PopOverOrigin = PropTypes.shape({
  vertical: PropTypes.string,
  horizontal: PropTypes.string
});
SpecialSelector.propTypes = {
  className: PropTypes.string,
  titleClassName: PropTypes.string,
  menuPaperClass: PropTypes.string,
  selectorDecoration: PropTypes.element,
  renderChildren: PropTypes.func.isRequired,
  testID: PropTypes.string,
  title: PropTypes.string,
  scrollbarRole: PropTypes.string,
  onSelect: PropTypes.func,
  transformOrigin: PopOverOrigin,
  anchorOrigin: PopOverOrigin,
  buttonAttributes: PropTypes.object
};
SpecialSelector.defaultProps = {
  className: undefined,
  titleClassName: '',
  menuPaperClass: '',
  testID: undefined,
  title: '',
  scrollbarRole: 'menuitem',
  selectorDecoration: undefined,
  onSelect: () => {},
  transformOrigin: MENU_TRANSFORM_ORIGIN,
  anchorOrigin: MENU_ANCHOR_ORIGIN,
  buttonAttributes: {}
};
export default React.memo(SpecialSelector);
//# sourceMappingURL=SpecialSelector.js.map